import type { FixingCompanyProps } from '@api/models/fixing-company';

const getFixingCompanyOptions = (
	fixingCompanies: Array<FixingCompanyProps>,
	selectedFixingCompanyId: number | null | undefined,
) => fixingCompanies
	.filter((c) => c.active || c.id === selectedFixingCompanyId)
	.map((c) => ({
		label: c.name,
		value: c.id,
	}));

export default getFixingCompanyOptions;
